function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import SetPasswordPopup from '../popups/set-password-popup';
import KickstarterShippingPopup from '../../containers/kickstarter-shipping';
import ItemTrackingNumbersPopup from '../../containers/item-tracking-numbers';
import { MockupManagerPopup } from '../popups/mockup-manager-popup';
import MaxPrintColorsLimitExceededPopup from '../popups/max-print-colors-limit-exceeded-popup';
import SelectPantonesPopup, { ConfirmItemPantones } from '../popups/select-pantones-popup';
import ConvertToOneColorPopup from '../popups/convert-to-one-color-popup';
import ConfirmDtgPopup from '../popups/confirm-dtg-popup';
import { NoDesignPopup } from '../popups/no-design-popup';
import BigAmountOfMockupsPopup from '../popups/big-amount-of-mockups-popup';
import OpenImagePopup from '../popups/open-image-popup';
import DesignNotesPopup from '../popups/design-notes-popup';
import SampleSizePopup from '../popups/sample-size-popup';
import ShareProductPopup from '../popups/share-product-popup';
import { TeeImagePopup } from '../popups/tee-image-popup';
import PricingFormationDetailsPopup from '../popups/pricing-formation-details-popup';
import InternetExplorerPopup from '../popups/internet-explorer-popup';
import { DeleteCompanyDepartmentPopup } from '../popups/delete-company-department-popup';
import PendingOrderConfirmAnAction from '../popups/pending-order-confirm-action-popup';
import InvitationPopup from '../popups/invitation-popup';
import { ConfirmCreateMyInventoryPopup } from '../popups/confirm-create-my-inventory-popup';
import { RemoveItemFromCartPopup } from '../popups/remove-item-from-cart-popup';

//********************************************
//TODO: DEPRECATED
//-------------------------------------------
//DON'T ADD ANY POPUPS HERE!!!!!
//IT'S DEPRECATED LOGIC
//-------------------------------------------
//TODO: DEPRECATED
//********************************************

export const popupsDictionary = {
  setPassword: function setPassword({
    onClose,
    requireApproveTerms = false
  }) {
    return /*#__PURE__*/React.createElement(SetPasswordPopup, {
      onClose: onClose,
      requireApproveTerms: requireApproveTerms
    });
  },
  kickstarterShipping: function kickstarterShipping({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(KickstarterShippingPopup, {
      onClose: onClose
    });
  },
  itemTrackingNumbers: function trackingNumbers({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(ItemTrackingNumbersPopup, {
      onClose: onClose
    });
  },
  mockupManager: function mockupManager(_ref) {
    let params = _extends({}, _ref);
    return /*#__PURE__*/React.createElement(MockupManagerPopup, params);
  },
  maxPrintColorsLimitExceededPopup: function maxPrintColorsLimitExceededPopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(MaxPrintColorsLimitExceededPopup, {
      onClose: onClose
    });
  },
  selectPantonesPopup: function selectPantonesPopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(SelectPantonesPopup, {
      onClose: onClose
    });
  },
  convertToOneColorPopup: function convertToOneColorPopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(ConvertToOneColorPopup, {
      onClose: onClose
    });
  },
  confirmDtgPopup: function confirmDtgPopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(ConfirmDtgPopup, {
      onClose: onClose
    });
  },
  bigAmountOfMockups: function bigAmountOfMockups({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(BigAmountOfMockupsPopup, {
      onClose: onClose
    });
  },
  openImage: function openImagePopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(OpenImagePopup, {
      onClose: onClose
    });
  },
  designNotesPopup: function designNotesPopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(DesignNotesPopup, {
      onClose: onClose
    });
  },
  sampleSizePopup: function sampleSizePopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(SampleSizePopup, {
      onClose: onClose
    });
  },
  confirmItemPantones: function confirmItemPantones(_ref2) {
    let params = _extends({}, _ref2);
    return /*#__PURE__*/React.createElement(ConfirmItemPantones, params);
  },
  shareProductPopup: function shareProductPopup({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(ShareProductPopup, {
      onClose: onClose
    });
  },
  teeImage: function teeImage(_ref3) {
    let params = _extends({}, _ref3);
    return /*#__PURE__*/React.createElement(TeeImagePopup, params);
  },
  pricingFormationDetails: function pricingFormationDetails(_ref4) {
    let {
        onClose
      } = _ref4,
      params = _objectWithoutProperties(_ref4, ["onClose"]);
    return /*#__PURE__*/React.createElement(PricingFormationDetailsPopup, _extends({
      onClose: onClose
    }, params));
  },
  noDesignPopup: function editQuantity({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(NoDesignPopup, {
      onClose: onClose
    });
  },
  internetExplorer: function internetExplorer({
    onClose
  }) {
    return /*#__PURE__*/React.createElement(InternetExplorerPopup, {
      onClose: onClose
    });
  },
  departmentDeleteConfirmationPopup: function deleteCompanyDepartmentPopup(_ref5) {
    let params = _extends({}, _ref5);
    return /*#__PURE__*/React.createElement(DeleteCompanyDepartmentPopup, params);
  },
  pendingOrderConfirmAnAction: function pendingOrderConfirmAnAction(_ref6) {
    let {
        onClose
      } = _ref6,
      params = _objectWithoutProperties(_ref6, ["onClose"]);
    return /*#__PURE__*/React.createElement(PendingOrderConfirmAnAction, _extends({
      onClose: onClose
    }, params));
  },
  invitationPopup: function invitationPopup() {
    return /*#__PURE__*/React.createElement(InvitationPopup, null);
  },
  confirmCreateMyInventoryPopup: function confirmCreateMyInventoryPopup() {
    return /*#__PURE__*/React.createElement(ConfirmCreateMyInventoryPopup, null);
  },
  removeItemFromCartPopup: function removeItemFromCartPopup() {
    return /*#__PURE__*/React.createElement(RemoveItemFromCartPopup, null);
  }
  //********************************************
  //TODO: DEPRECATED
  //-------------------------------------------
  //DON'T ADD ANY POPUPS HERE!!!!!
  //IT'S DEPRECATED LOGIC
  //-------------------------------------------
  //TODO: DEPRECATED
  //********************************************
};